
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Gestational_trophoblastic_tumor",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Gestational_trophoblastic_tumor.vue